const HERO_VIDEO =
  "/images/hero_background.mp4";

export default function Hero() {
  const goContact = (e) => {
    e.preventDefault();
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="hero" data-testid="hero-section">
      <video
        className="hero__video"
        src={HERO_VIDEO}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        data-testid="hero-video"
      />
      <div className="hero__overlay" />
      <div className="hero__grain" />

      <div className="container">
        <div className="hero__content">
          <div className="hero__line hero__line--1">
            <span className="eyebrow hero__eyebrow">
              Dr. Kalpana Randhawa · Jaipur
            </span>
          </div>

          <h1 className="hero__title">
            <span className="hero__line hero__line--2">
              Where the Mind Finds <em>Peace</em>
            </span>
            <br />
            <span className="hero__line hero__line--3">
              and the Soul Finds <em>Power</em>
            </span>
          </h1>

          <p className="hero__sub hero__line hero__line--4">
            Integrating Clinical Psychology with Ancient Pranic Wisdom — a sanctuary
            for the mind, the body, and the energy that runs between them.
          </p>

          <div className="hero__actions hero__line hero__line--5">
            <a
              href="#contact"
              onClick={goContact}
              className="btn btn--solid pulse-ring"
              data-testid="hero-cta-book"
            >
              <i className="fa-solid fa-calendar-day"></i>
              Book an Appointment
            </a>
            <div className="hero__meta">
              <i className="fa-solid fa-shield-heart"></i>
              <span>15+ years · 2000+ Lives Transformed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
